import { forwardRef, PropsWithChildren } from 'react';
import style from './dropdown.module.css';
import { ClassName, cn } from '../../../../utils';

type ProfileDropdownProps = PropsWithChildren<{
  id: string;
  className?: ClassName;
}>;

export const ProfileDropdown = forwardRef<
  HTMLMenuElement,
  ProfileDropdownProps
>(({ id, children, className }, ref) => {
  return (
    <menu role="menu" id={id} className={cn(style.menu, className)} ref={ref}>
      {children}
    </menu>
  );
});
